import { useState, useEffect } from "react";
import { DocumentDetailsFolder } from "../DocumentDetailsFolder/DocumentDetailsFolder";
import { EmptyListComponent } from "../../../components/EmptyListComponent/EmptyListComponent";
import { DocumentHierarchyDTO } from "types";

type Props = {
  documents: DocumentHierarchyDTO[];
  projectId: string;
};

export const DocumentDetailsContainer = ({ documents }: Props) => {
  const [expandedIds, setExpandedIds] = useState<Set<string>>(new Set());

  // Initialize with all document IDs expanded by default
  useEffect(() => {
    if (documents && documents.length > 0) {
      const allIds = new Set(documents.map(doc => doc.id));
      setExpandedIds(allIds);
    }
  }, [documents]);

  const toggleExpand = (id: string) => {
    setExpandedIds((prevIds) => {
      const newIds = new Set(prevIds);
      if (newIds.has(id)) {
        newIds.delete(id);
      } else {
        newIds.add(id);
      }
      return newIds;
    });
  };

  return (
    <div className="py-4">
      <div className="d-flex flex-column gap-3">
        {documents.length > 0 ? (
          documents.map((document) => (
            <DocumentDetailsFolder
              key={document.id}
              document={document}
              isExpanded={expandedIds.has(document.id)}
              onToggleExpand={() => toggleExpand(document.id)}
            />
          ))
        ) : (
          <EmptyListComponent 
            message="No documents available for this project"
          />
        )}
      </div>
    </div>
  );
};